import { defineStore } from 'pinia'
import {FundsApi} from '@/api/funds_api'

export const useFundStore = defineStore('funds', {
	state: () => ({
		funds: [],
	}),
	actions: {
		async initializeFunds() {
			const resp = await FundsApi.getFunds({ '$top': 1000 })
			this.funds = resp.value || []
		},
		async reloadFunds() {
			const resp = await FundsApi.getFunds({ '$top': 1000 })
			this.funds = resp.value || []
		}
	},
})
